/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Sign_In_SubtitleInputs */

const en_auth_sign_in_subtitle = /** @type {(inputs: Auth_Sign_In_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to your SSC account`)
};

const es_auth_sign_in_subtitle = /** @type {(inputs: Auth_Sign_In_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión en tu cuenta SSC`)
};

const fr_auth_sign_in_subtitle = /** @type {(inputs: Auth_Sign_In_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous à votre compte SSC`)
};

const de_auth_sign_in_subtitle = /** @type {(inputs: Auth_Sign_In_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich bei deinem SSC-Konto an`)
};

const ja_auth_sign_in_subtitle = /** @type {(inputs: Auth_Sign_In_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSCアカウントにログイン`)
};

const zh_auth_sign_in_subtitle = /** @type {(inputs: Auth_Sign_In_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录您的 SSC 账号`)
};

const ar_auth_sign_in_subtitle = /** @type {(inputs: Auth_Sign_In_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم بتسجيل الدخول إلى حساب SSC الخاص بك`)
};

const id_auth_sign_in_subtitle = /** @type {(inputs: Auth_Sign_In_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk ke akun SSC Anda`)
};

const it_auth_sign_in_subtitle = /** @type {(inputs: Auth_Sign_In_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi al tuo account SSC`)
};

const ru_auth_sign_in_subtitle = /** @type {(inputs: Auth_Sign_In_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите в свой аккаунт SSC`)
};

const pt_auth_sign_in_subtitle = /** @type {(inputs: Auth_Sign_In_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre na sua conta SSC`)
};

const ko_auth_sign_in_subtitle = /** @type {(inputs: Auth_Sign_In_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSC 계정에 로그인하세요`)
};

/**
* | output |
* | --- |
* | "Sign in to your SSC account" |
*
* @param {Auth_Sign_In_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const auth_sign_in_subtitle = /** @type {((inputs?: Auth_Sign_In_SubtitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sign_In_SubtitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_sign_in_subtitle(inputs)
	if (locale === "es") return es_auth_sign_in_subtitle(inputs)
	if (locale === "fr") return fr_auth_sign_in_subtitle(inputs)
	if (locale === "de") return de_auth_sign_in_subtitle(inputs)
	if (locale === "ja") return ja_auth_sign_in_subtitle(inputs)
	if (locale === "zh") return zh_auth_sign_in_subtitle(inputs)
	if (locale === "ar") return ar_auth_sign_in_subtitle(inputs)
	if (locale === "id") return id_auth_sign_in_subtitle(inputs)
	if (locale === "it") return it_auth_sign_in_subtitle(inputs)
	if (locale === "ru") return ru_auth_sign_in_subtitle(inputs)
	if (locale === "pt") return pt_auth_sign_in_subtitle(inputs)
	return ko_auth_sign_in_subtitle(inputs)
});